import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import DatePicker from 'component/utils/DatePicker'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelect'
import HierarchySelect from 'component/hierarchy/HierarchySelect'
import { CustomMenuList as MenuList } from 'component/reactSelect/CustomMenuList'
import { CustomMultiValue as MultiValueContainer } from 'component/reactSelect/CustomMultiValue'

import moment from 'moment'
import _ from 'lodash'

const ALL = 'all'

class FilterForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sectionDisabled: false,
      lmDisabled: false,
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { submit, values } = this.props

    const selectedBranches = values.listRegionsAndBranchs || []
    const idBranches = selectedBranches
      .filter((item) => item.isBranch !== undefined && item.value !== ALL)
      .map((item) => item.value)
    const idRegions = selectedBranches
      .filter((item) => item.isBranch === undefined && item.value !== ALL)
      .map((item) => item.value)

    const sections = values.cdSection ? values.cdSection : []
    const lsSections = sections
      .filter((item) => item.value !== ALL)
      .map((item) => item.value)

    const params = {
      ...values,
      cdSection: null,
      dtStart: values.dtStart
        ? moment(values.dtStart).format('DD/MM/YYYY')
        : null,
      dtEnd: values.dtEnd ? moment(values.dtEnd).format('DD/MM/YYYY') : null,
      idBranches,
      idRegions,
      lsSections,
      countIrc: true,
    }

    submit(params)
  }

  branchChange = (selectedOption, input) => {
    input.value = selectedOption

    const event = {
      target: input,
    }

    input.onChange(event)
  }

  hierarchyChange = (selectedOption, input) => {
    input.value = selectedOption

    const event = {
      target: input,
    }

    this.setState({ lmDisabled: !!selectedOption && !!selectedOption.length })
    input.onChange(event)
  }

  handleChangeLm = (event) => {
    const { fields } = this.props

    this.setState({ sectionDisabled: !!event.target.value })
    fields.cdLm.input.onChange(event)
  }

  onIncludeLotChange = (e, input) => {
    const { changeIncludeLot } = this.props

    input.value = e.target.checked ? 1 : 0

    const event = {
      target: input,
    }

    input.onChange(event)
    changeIncludeLot(e)
  }

  disableFilter = () => {
    const { values } = this.props

    return _.isEmpty(values.dtStart) || _.isEmpty(values.dtEnd)
  }

  render() {
    const {
      translate,
      fields,
      className,
      changeIncludeProvider,
      includeProvider,
      showTable,
      getCsv,
    } = this.props

    const { sectionDisabled, lmDisabled } = this.state

    return (
      <Row>
        <Col xs={12}>
          <div className={`filter-inventory margin-top-double ${className}`}>
            <div className='flex-container'>
              <div className='inventory-title margin-bottom-small'>
                <h4 className='strong color-default-dark'>
                  {translate('rotativeInventory.stockCounting')}
                </h4>
              </div>

              <div className='big margin-bottom-small'>
                <Field
                  {...fields.listRegionsAndBranchs}
                  hint={translate('rotativeInventory.dsBranch')}
                >
                  <RegionBranchMultipleSelect
                    id='listRegionsAndBranchs'
                    {...fields.listRegionsAndBranchs.input}
                    placeholder=''
                    components={{ MenuList, MultiValueContainer }}
                    className='react-select-collapsible'
                    translate={translate}
                    onChange={(event) =>
                      this.branchChange(
                        event.target.value,
                        fields.listRegionsAndBranchs.input
                      )
                    }
                    allOption
                  />
                </Field>
              </div>

              <div className='big margin-bottom-small'>
                <Field
                  {...fields.cdSection}
                  hint={translate('rotativeInventory.section')}
                >
                  <HierarchySelect
                    id='cdSection'
                    {...fields.cdSection.input}
                    query={{ level: 2 }}
                    onChange={(selectedOption) =>
                      this.hierarchyChange(
                        selectedOption,
                        fields.cdSection.input
                      )
                    }
                    disabled={sectionDisabled}
                    isMulti
                    components={{ MenuList, MultiValueContainer }}
                    className='react-select-collapsible'
                    translate={translate}
                    allOption
                  />
                </Field>
              </div>

              <div className='small margin-bottom-small'>
                <Field
                  {...fields.cdLm}
                  hint={translate('rotativeInventory.cdLm')}
                >
                  <Input
                    id='cdLm'
                    {...fields.cdLm.input}
                    onChange={this.handleChangeLm}
                    disabled={lmDisabled}
                  />
                </Field>
              </div>

              <div className='date small'>
                <Field
                  {...fields.dtStart}
                  glyph='glyph glyph-calendar'
                  className='margin-bottom-small'
                >
                  <DatePicker
                    {...fields.dtStart.input}
                    placeholder={translate('rotativeInventory.dtStart')}
                    isOutsideRange={(date) =>
                      moment(date).isAfter(fields.dtEnd.input.value)
                    }
                  />
                </Field>
              </div>

              <div className='date small'>
                <Field
                  {...fields.dtEnd}
                  glyph='glyph glyph-calendar'
                  className='margin-bottom-small'
                >
                  <DatePicker
                    {...fields.dtEnd.input}
                    placeholder={translate('rotativeInventory.dtEnd')}
                    isOutsideRange={(date) =>
                      moment(date).isBefore(fields.dtStart.input.value)
                    }
                  />
                </Field>
              </div>

              <div className='small dont-break-lines'>
                <div>
                  <Field
                    {...fields.includeLot}
                    className='field-inline-block'
                    radio
                  >
                    <Input
                      {...fields.includeLot.input}
                      id='includeLot'
                      type='checkbox'
                      label={translate('rotativeInventory.includeBatch')}
                      onChange={(e) =>
                        this.onIncludeLotChange(e, fields.includeLot.input)
                      }
                    />
                  </Field>
                </div>

                <div className='dont-break-lines margin-bottom'>
                  <Field
                    {...fields.includeProvider}
                    className='field-inline-block'
                    radio
                  >
                    <Input
                      {...fields.includeProvider.input}
                      id='includeProvider'
                      type='checkbox'
                      label={translate('rotativeInventory.includeProvider')}
                      onChange={changeIncludeProvider}
                      checked={includeProvider}
                    />
                  </Field>
                </div>
              </div>

              <div className='small div-button'>
                <button
                  role='button'
                  type='button'
                  onClick={this.handleSubmit}
                  className='button button-primary button-full'
                  disabled={this.disableFilter()}
                >
                  {translate('filter_button_label')}
                </button>
              </div>
            </div>
          </div>
        </Col>
        {showTable && (
          <Col xs={12} md={3} mdOffset={9}>
            <button
              type='button'
              onClick={getCsv}
              className='button button-primary button-full'
            >
              {translate('rotativeInventory.exportCsv')}
            </button>
          </Col>
        )}
      </Row>
    )
  }
}

FilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  changeIncludeLot: PropTypes.func.isRequired,
  includeProvider: PropTypes.bool.isRequired,
  changeIncludeProvider: PropTypes.func.isRequired,
  className: PropTypes.string,
  showTable: PropTypes.bool.isRequired,
  getCsv: PropTypes.func.isRequired,
}

const fields = [
  'listRegionsAndBranchs',
  'cdSection',
  'cdLm',
  'dtStart',
  'dtEnd',
  'includeLot',
  'includeProvider',
]

export default Form({ fields })(FilterForm)

export { FilterForm }
